<div class="container-fluid mt-4">
  <!-- MODO REGULAR (LISTADO Y EDICIÓN BÁSICA) -->
  <div *ngIf="!isFullViewMode" class="row">
    <!-- Columna de la lista de clientes -->
    <div class="col-md-5">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4>Listado de Clientes</h4>
        <button class="btn btn-primary btn-sm" (click)="startNewClient()">
          <i class="bi bi-plus-circle-fill me-1"></i> Nuevo Cliente
        </button>
      </div>

      <!-- Campo de búsqueda -->
      <div class="mb-3">
        <input 
          type="text" 
          class="form-control form-control-sm" 
          placeholder="Buscar por nombre, teléfono o email..." 
          [formControl]="clientSearchControl"
        >
      </div>

      <!-- Lista de clientes (Modificada para usar el array) -->
      <div class="list-group client-list">
        <ng-container *ngIf="filteredClients$ | async as clients; else loadingClients">
          <a *ngFor="let client of clients"
             href="javascript:void(0);"
             class="list-group-item list-group-item-action"
             [class.active]="selectedClient?.id === client.id"
             (click)="selectClient(client)">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{ client.name }}</h5>
            </div>
            <p class="mb-1 small">Tel: {{ client.phone || 'N/A' }}</p>
            <small>Email: {{ client.email || 'N/A' }}</small>
          </a>
          <div *ngIf="filteredClients.length === 0" class="list-group-item">
            <span *ngIf="clientSearchControl.value; else noClientsAtAll">
              No se encontraron clientes con el término de búsqueda.
            </span>
            <ng-template #noClientsAtAll>
              No hay clientes registrados.
            </ng-template>
          </div>
        </ng-container>
        <ng-template #loadingClients>
          <div class="list-group-item">Cargando clientes...</div>
        </ng-template>
      </div>
    </div>

    <!-- Columna del formulario -->
     <div class="col-md-7">
      <!-- Formulario de Cliente -->
      <div class="card shadow-sm mb-4">
        <div class="card-header bg-white d-flex justify-content-between align-items-center">
          <h5 class="mb-0">{{ isNewClientMode ? 'Nuevo Cliente' : (selectedClient ? 'Editar Datos' : 'Seleccione un Cliente') }}</h5>
          <button *ngIf="selectedClient && !isNewClientMode" type="button" class="btn btn-primary btn-sm" (click)="openFullClientView()" title="Ver cliente en vista completa e historial">
            <i class="bi bi-arrows-fullscreen me-1"></i> Ver Cliente
          </button>
        </div>
        <div class="card-body">
          <div *ngIf="!selectedClient && !isNewClientMode" class="text-center py-4 text-muted">
            <i class="bi bi-person-bounding-box display-4 d-block mb-2"></i>
            <p>Seleccione un cliente de la lista para ver o editar sus datos.</p>
          </div>

          <form *ngIf="selectedClient || isNewClientMode" [formGroup]="clientForm" (ngSubmit)="onSaveClient()">
            <div class="mb-3">
              <label class="form-label small fw-bold text-muted text-uppercase">Nombre Completo *</label>
              <input type="text" class="form-control" formControlName="name">
            </div>
            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Teléfono</label>
                <input type="tel" class="form-control" formControlName="phone">
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Email</label>
                <input type="email" class="form-control" formControlName="email">
              </div>
            </div>

            <!-- Nuevos campos de perfil del cliente -->
            <div class="row">
              <div class="col-md-4 mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Cédula</label>
                <input type="text" class="form-control bg-light" placeholder="000-0000000-0" formControlName="cedula">
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Rango de Peso</label>
                <select class="form-select rounded-16 bg-light" formControlName="weightRange">
                  <option [ngValue]="null">Seleccionar peso...</option>
                  <option value="< 130 lbs">&lt; 130 lbs</option>
                  <option value="130 -165 lbs">130 - 165 lbs</option>
                  <option value="165 - 200 lbs">165 - 200 lbs</option>
                  <option value="200 - 230 lbs">200 - 230 lbs</option>
                  <option value="> 230 lbs">&gt; 230 lbs</option>
                </select>
              </div>
              <div class="col-md-4 mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Nivel de Ciclista</label>
                <select class="form-select rounded-16 bg-light" formControlName="cyclistLevel">
                  <option [ngValue]="null">Seleccionar nivel...</option>
                  <option value="Recreativo">Recreativo</option>
                  <option value="Entusiasta">Entusiasta</option>
                  <option value="Avanzado">Avanzado</option>
                  <option value="Competitivo / Pro">Competitivo / Pro</option>
                </select>
              </div>
            </div>
            
            <div class="d-flex justify-content-between mt-3">
              <div>
                <button type="submit" class="btn btn-success me-2" [disabled]="clientForm.invalid || isSavingClient">
                  {{ isSavingClient ? 'Guardando...' : 'Guardar' }}
                </button>
                <button type="button" class="btn btn-light" (click)="clearSelection()">Cancelar</button>
              </div>
              <button *ngIf="selectedClient" type="button" class="btn btn-outline-danger" (click)="onDeleteClient()" [disabled]="isDeleting">
                Eliminar
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Sección para Bicicletas -->
      <div *ngIf="selectedClient && !isNewClientMode" class="card mt-4">
        <div class="card-header">
          <h5 class="mb-0">Bicicletas de {{ selectedClient.name }}</h5>
        </div>
        <div class="card-body">
          <h6>Agregar Nueva Bicicleta</h6>
          <form [formGroup]="bikeForm" (ngSubmit)="onAddBike()" class="mb-4">
            <div class="row">
              <div class="col-md-6 mb-2">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Marca *</label>
                <input type="text" class="form-control form-control-sm" placeholder="Marca *" formControlName="brand">
              </div>
              <div class="col-md-6 mb-2">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Modelo</label>
                <input type="text" class="form-control form-control-sm" placeholder="Modelo" formControlName="model">
              </div>
              <div class="col-md-4 mb-2">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Color *</label>
                <input type="text" class="form-control form-control-sm" placeholder="Color *" formControlName="color">
              </div>
              <div class="col-md-4 mb-2">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Chasis</label>
                <input type="text" class="form-control form-control-sm" placeholder="Chasis" formControlName="chassis">
              </div>
              <div class="col-md-4 mb-2">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Año</label>
                <input type="text" class="form-control form-control-sm" placeholder="Año" formControlName="year">
              </div>
            </div>

            <!-- Perfil Mecánico Avanzado (Opcional) -->
            <hr class="my-3 border-light-subtle">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="small fw-bold text-muted text-uppercase mb-0">
                <i class="bi bi-gear-wide-connected me-1 text-primary"></i>Perfil Mecánico Avanzado (Opcional)
              </h6>
              <!-- Switches isBikeActive y isEBike -->
              <div class="d-flex align-items-center gap-3">
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="isBikeActiveSwitch" formControlName="isActive" style="cursor: pointer;">
                  <label class="form-check-label small fw-bold text-muted text-uppercase" for="isBikeActiveSwitch">
                    ¿Activa?
                  </label>
                </div>
                <div class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="isEBikeSwitch" formControlName="isEBike" style="cursor: pointer;">
                  <label class="form-check-label small fw-bold text-muted text-uppercase" for="isEBikeSwitch">
                    <i class="bi bi-lightning-charge-fill text-warning me-1"></i>¿Es E-Bike?
                  </label>
                </div>
              </div>
            </div>

            <div class="row g-2 mb-3">
              <!-- Categoría -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Categoría</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="category">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="MTB">MTB</option>
                  <option value="Ruta">Ruta</option>
                  <option value="Gravel">Gravel</option>
                  <option value="Urbana">Urbana</option>
                  <option value="Enduro / DH">Enduro / DH</option>
                  <option value="BMX">BMX</option>
                  <option value="Triatlón">Triatlón</option>
                  <option value="Otra">Otra</option>
                </select>
              </div>

              <!-- Material del Cuadro -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Material Cuadro</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="frameMaterial">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="Aluminio">Aluminio</option>
                  <option value="Carbono">Carbono</option>
                  <option value="Acero">Acero</option>
                  <option value="Titanio">Titanio</option>
                  <option value="Otro">Otro</option>
                </select>
              </div>

              <!-- Frecuencia de Uso -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Frecuencia de Uso</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="usageFrequency">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="Ocasional (1-2 al mes)">Ocasional (1-2 al mes)</option>
                  <option value="Recreativo (1-2 por semana)">Recreativo (1-2 por semana)</option>
                  <option value="Frecuente (3-5 por semana)">Frecuente (3-5 por semana)</option>
                  <option value="Diario / Transporte">Diario / Transporte</option>
                  <option value="Competencia">Competencia</option>
                </select>
              </div>

              <!-- Tipo de Suspensión -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Tipo Suspensión</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="suspensionType">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="Rígida">Rígida</option>
                  <option value="Delantera (Hardtail)">Delantera (Hardtail)</option>
                  <option value="Doble (Full Suspension)">Doble (Full Suspension)</option>
                </select>
              </div>

              <!-- Tipo de Frenos -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Tipo de Frenos</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="brakeType">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="Disco Hidráulico">Disco Hidráulico</option>
                  <option value="Disco Mecánico">Disco Mecánico</option>
                  <option value="Rim Brake (Herradura/V-Brake)">Rim Brake (Herradura/V-Brake)</option>
                </select>
              </div>

              <!-- Gama de Transmisión -->
              <div class="col-md-4">
                <label class="form-label small fw-bold text-muted text-uppercase mb-1">Gama Transmisión</label>
                <select class="form-select form-select-sm rounded-16 bg-light" formControlName="drivetrainLevel">
                  <option [ngValue]="null">Seleccionar...</option>
                  <option value="Gama Entrada">Gama Entrada</option>
                  <option value="Gama Media">Gama Media</option>
                  <option value="Gama Alta">Gama Alta</option>
                  <option value="Tope de Gama / Electrónico">Tope de Gama / Electrónico</option>
                </select>
              </div>
            </div>

            <button type="submit" class="btn btn-success btn-sm w-100" [disabled]="bikeForm.invalid || isSavingBike">
              {{ isSavingBike ? 'Agregando...' : 'Agregar Bicicleta' }}
            </button>
          </form>
          
          <hr>
          <h6>Bicicletas Registradas</h6>
          <ul class="list-group">
            <ng-container *ngIf="clientBikes$ | async as bikes">
              <li *ngFor="let bike of bikes" class="list-group-item">
                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <strong>{{ bike.brand }} {{ bike.model || '' }}</strong>
                    <span *ngIf="bike.isActive === false" class="badge bg-danger ms-2"><i class="bi bi-x-circle me-1"></i>Inactiva</span>
                    <span *ngIf="bike.isActive !== false" class="badge bg-success-subtle text-success border border-success-subtle ms-2"><i class="bi bi-check-circle me-1"></i>Activa</span>
                  </div>
                  <span *ngIf="bike.isEBike" class="badge bg-warning text-dark"><i class="bi bi-lightning-charge-fill"></i> E-Bike</span>
                </div>
                <div class="small text-muted mt-1">Color: {{ bike.color }}</div>
                <small *ngIf="bike.chassis" class="d-block text-muted">Chasis: {{ bike.chassis }}</small>
                <small *ngIf="bike.year" class="d-block text-muted">Año: {{ bike.year }}</small>
                <div *ngIf="bike.category || bike.frameMaterial || bike.suspensionType || bike.brakeType || bike.drivetrainLevel" class="d-flex flex-wrap gap-1 mt-1">
                  <span *ngIf="bike.category" class="badge bg-light text-dark border">{{ bike.category }}</span>
                  <span *ngIf="bike.frameMaterial" class="badge bg-light text-dark border">{{ bike.frameMaterial }}</span>
                  <span *ngIf="bike.suspensionType" class="badge bg-light text-dark border">{{ bike.suspensionType }}</span>
                  <span *ngIf="bike.brakeType" class="badge bg-light text-dark border">{{ bike.brakeType }}</span>
                  <span *ngIf="bike.drivetrainLevel" class="badge bg-light text-dark border">{{ bike.drivetrainLevel }}</span>
                </div>
                <div class="d-flex flex-wrap justify-content-end gap-2 mt-2 pt-2 border-top">
                  <button type="button" class="btn btn-sm" [ngClass]="bike.isActive === false ? 'btn-outline-success' : 'btn-outline-warning'" (click)="toggleBikeStatus(bike)">
                    <i class="bi" [ngClass]="bike.isActive === false ? 'bi-check2-circle' : 'bi-pause-circle'"></i> {{ bike.isActive === false ? 'Activar' : 'Marcar Inactiva' }}
                  </button>
                  <button type="button" class="btn btn-outline-info btn-sm" (click)="openFullClientView(); loadBikeWorks(bike)">
                    <i class="bi bi-clock-history me-1"></i> Ver historial de esta bicicleta
                  </button>
                  <button type="button" class="btn btn-outline-secondary btn-sm" (click)="printBikeMaintenanceHistory(bike)">
                    <i class="bi bi-printer me-1"></i> Imprimir historial
                  </button>
                </div>
              </li>
              <li *ngIf="bikes.length === 0" class="list-group-item text-muted">
                Este cliente no tiene bicicletas registradas.
              </li>
            </ng-container>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- ======================================================== -->
  <!-- VISTA COMPLETA DE CLIENTE (MODALIDAD: VER CLIENTE)       -->
  <!-- ======================================================== -->
  <div *ngIf="isFullViewMode && selectedClient" class="full-client-view">
    <!-- Barra Superior de Navegación -->
    <div class="d-flex justify-content-between align-items-center mb-3 p-3 bg-white border rounded shadow-sm">
      <div class="d-flex align-items-center gap-3">
        <button type="button" class="btn btn-outline-secondary btn-sm" (click)="exitFullClientView()">
          <i class="bi bi-arrow-left me-1"></i> Volver a Lista de Clientes
        </button>
        <h4 class="mb-0 text-truncate">
          <i class="bi bi-person-badge text-primary me-2"></i>Ficha del Cliente: <span class="fw-bold">{{ selectedClient.name }}</span>
        </h4>
      </div>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-primary btn-sm" (click)="loadClientWorks()">
          <i class="bi bi-clock-history me-1"></i> Ver Historial de Trabajos
        </button>
      </div>
    </div>

    <div class="row">
      <!-- COLUMNA IZQUIERDA: DATOS DEL CLIENTE Y BICICLETAS -->
      <div class="col-lg-5 col-md-12 mb-4">
        <!-- Tarjeta: Datos del Cliente -->
        <div class="card shadow-sm mb-4">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0"><i class="bi bi-person-vcard text-primary me-2"></i>Datos del Cliente</h5>
            <button type="button" class="btn btn-info btn-sm text-white" (click)="loadClientWorks()">
              <i class="bi bi-clock-history me-1"></i> Ver Historial de Trabajos
            </button>
          </div>
          <div class="card-body">
            <form [formGroup]="clientForm" (ngSubmit)="onSaveClient()">
              <div class="mb-3">
                <label class="form-label small fw-bold text-muted text-uppercase">Nombre Completo *</label>
                <input type="text" class="form-control" formControlName="name">
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Teléfono</label>
                  <input type="tel" class="form-control" formControlName="phone">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Email</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
              </div>

              <!-- Nuevos campos de perfil del cliente -->
              <div class="row">
                <div class="col-md-4 mb-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Cédula</label>
                  <input type="text" class="form-control bg-light" placeholder="000-0000000-0" formControlName="cedula">
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Rango de Peso</label>
                  <select class="form-select rounded-16 bg-light" formControlName="weightRange">
                    <option [ngValue]="null">Seleccionar peso...</option>
                    <option value="< 130 lbs">&lt; 130 lbs</option>
                    <option value="130 -165 lbs">130 - 165 lbs</option>
                    <option value="165 - 200 lbs">165 - 200 lbs</option>
                    <option value="200 - 230 lbs">200 - 230 lbs</option>
                    <option value="> 230 lbs">&gt; 230 lbs</option>
                  </select>
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label small fw-bold text-muted text-uppercase">Nivel de Ciclista</label>
                  <select class="form-select rounded-16 bg-light" formControlName="cyclistLevel">
                    <option [ngValue]="null">Seleccionar nivel...</option>
                    <option value="Recreativo">Recreativo</option>
                    <option value="Entusiasta">Entusiasta</option>
                    <option value="Avanzado">Avanzado</option>
                    <option value="Competitivo / Pro">Competitivo / Pro</option>
                  </select>
                </div>
              </div>

              <div class="d-flex justify-content-between mt-2">
                <button type="submit" class="btn btn-success btn-sm" [disabled]="clientForm.invalid || isSavingClient">
                  {{ isSavingClient ? 'Guardando...' : 'Guardar Cambios' }}
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- Tarjeta: Bicicletas del Cliente -->
        <div class="card shadow-sm">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0"><i class="bi bi-bicycle text-primary me-2"></i>Bicicletas de {{ selectedClient.name }}</h5>
          </div>
          <div class="card-body">
            <h6>Bicicletas Registradas</h6>
            <ul class="list-group mb-4">
              <ng-container *ngIf="clientBikes$ | async as bikes">
                <li *ngFor="let bike of bikes" class="list-group-item" [class.border-primary]="selectedBikeForHistory?.id === bike.id">
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <strong class="fs-6">{{ bike.brand }} {{ bike.model || '' }}</strong>
                      <span *ngIf="bike.isActive === false" class="badge bg-danger ms-2"><i class="bi bi-x-circle me-1"></i>Inactiva</span>
                      <span *ngIf="bike.isActive !== false" class="badge bg-success-subtle text-success border border-success-subtle ms-2"><i class="bi bi-check-circle me-1"></i>Activa</span>
                    </div>
                    <span *ngIf="bike.isEBike" class="badge bg-warning text-dark"><i class="bi bi-lightning-charge-fill"></i> E-Bike</span>
                  </div>
                  <div class="small text-muted mt-1">Color: {{ bike.color }}</div>
                  <small *ngIf="bike.chassis" class="d-block text-muted">Chasis: {{ bike.chassis }}</small>
                  <small *ngIf="bike.year" class="d-block text-muted">Año: {{ bike.year }}</small>
                  <div *ngIf="bike.category || bike.frameMaterial || bike.suspensionType || bike.brakeType || bike.drivetrainLevel" class="d-flex flex-wrap gap-1 mt-1">
                    <span *ngIf="bike.category" class="badge bg-light text-dark border">{{ bike.category }}</span>
                    <span *ngIf="bike.frameMaterial" class="badge bg-light text-dark border">{{ bike.frameMaterial }}</span>
                    <span *ngIf="bike.suspensionType" class="badge bg-light text-dark border">{{ bike.suspensionType }}</span>
                    <span *ngIf="bike.brakeType" class="badge bg-light text-dark border">{{ bike.brakeType }}</span>
                    <span *ngIf="bike.drivetrainLevel" class="badge bg-light text-dark border">{{ bike.drivetrainLevel }}</span>
                  </div>

                  <!-- Botones de Acción para cada Bicicleta -->
                  <div class="d-flex flex-wrap gap-2 mt-3 pt-2 border-top">
                    <button type="button" class="btn btn-sm" [ngClass]="bike.isActive === false ? 'btn-outline-success' : 'btn-outline-warning'" (click)="toggleBikeStatus(bike)">
                      <i class="bi" [ngClass]="bike.isActive === false ? 'bi-check2-circle' : 'bi-pause-circle'"></i> {{ bike.isActive === false ? 'Activar' : 'Marcar Inactiva' }}
                    </button>
                    <button type="button" class="btn btn-outline-info btn-sm flex-fill" (click)="loadBikeWorks(bike)" [class.active]="selectedBikeForHistory?.id === bike.id">
                      <i class="bi bi-clock-history me-1"></i> Ver historial para esta bicicleta
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm flex-fill" (click)="printBikeMaintenanceHistory(bike)">
                      <i class="bi bi-printer me-1"></i> Imprimir historial de mantenimientos
                    </button>
                  </div>
                </li>
                <li *ngIf="bikes.length === 0" class="list-group-item text-muted">
                  Este cliente no tiene bicicletas registradas.
                </li>
              </ng-container>
            </ul>

            <!-- Formulario Desplegable para Agregar Bicicleta -->
            <details class="border rounded p-3 bg-light">
              <summary class="fw-bold text-primary" style="cursor: pointer;">
                <i class="bi bi-plus-circle me-1"></i> Agregar Nueva Bicicleta
              </summary>
              <form [formGroup]="bikeForm" (ngSubmit)="onAddBike()" class="mt-3">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Marca *</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Marca *" formControlName="brand">
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Modelo</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Modelo" formControlName="model">
                  </div>
                  <div class="col-md-4 mb-2">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Color *</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Color *" formControlName="color">
                  </div>
                  <div class="col-md-4 mb-2">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Chasis</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Chasis" formControlName="chassis">
                  </div>
                  <div class="col-md-4 mb-2">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Año</label>
                    <input type="text" class="form-control form-control-sm" placeholder="Año" formControlName="year">
                  </div>
                </div>

                <div class="row g-2 mb-3 mt-1">
                  <div class="col-md-4">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Categoría</label>
                    <select class="form-select form-select-sm rounded-16 bg-white" formControlName="category">
                      <option [ngValue]="null">Seleccionar...</option>
                      <option value="MTB">MTB</option>
                      <option value="Ruta">Ruta</option>
                      <option value="Gravel">Gravel</option>
                      <option value="Urbana">Urbana</option>
                      <option value="Enduro / DH">Enduro / DH</option>
                      <option value="BMX">BMX</option>
                      <option value="Triatlón">Triatlón</option>
                      <option value="Otra">Otra</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label small fw-bold text-muted text-uppercase mb-1">Material Cuadro</label>
                    <select class="form-select form-select-sm rounded-16 bg-white" formControlName="frameMaterial">
                      <option [ngValue]="null">Seleccionar...</option>
                      <option value="Aluminio">Aluminio</option>
                      <option value="Carbono">Carbono</option>
                      <option value="Acero">Acero</option>
                      <option value="Titanio">Titanio</option>
                      <option value="Otro">Otro</option>
                    </select>
                  </div>
                  <div class="col-md-4 d-flex align-items-end gap-3">
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" id="isBikeActiveSwitchFull" formControlName="isActive" style="cursor: pointer;">
                      <label class="form-check-label small fw-bold text-muted text-uppercase" for="isBikeActiveSwitchFull">
                        ¿Activa?
                      </label>
                    </div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" id="isEBikeSwitchFull" formControlName="isEBike" style="cursor: pointer;">
                      <label class="form-check-label small fw-bold text-muted text-uppercase" for="isEBikeSwitchFull">
                        <i class="bi bi-lightning-charge-fill text-warning me-1"></i>¿Es E-Bike?
                      </label>
                    </div>
                  </div>
                </div>

                <button type="submit" class="btn btn-success btn-sm w-100" [disabled]="bikeForm.invalid || isSavingBike">
                  {{ isSavingBike ? 'Agregando...' : 'Guardar Bicicleta' }}
                </button>
              </form>
            </details>
          </div>
        </div>
      </div>

      <!-- COLUMNA DERECHA: HISTORIAL DE TRABAJOS Y DETALLE SELECCIONADO -->
      <div class="col-lg-7 col-md-12">
        <div class="card shadow-sm mb-4">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <div>
              <h5 class="mb-0">
                <i class="bi bi-tools text-primary me-2"></i>
                <span *ngIf="activeHistoryFilter === 'all'">Historial de Trabajos del Cliente (Todos)</span>
                <span *ngIf="activeHistoryFilter === 'bike'">Historial: {{ selectedBikeForHistory?.brand }} {{ selectedBikeForHistory?.model || '' }} - {{ selectedBikeForHistory?.color }}</span>
                <span *ngIf="!activeHistoryFilter">Historial de Trabajos</span>
              </h5>
              <small class="text-muted" *ngIf="activeHistoryFilter === 'all'">Todos los servicios registrados para {{ selectedClient.name }}</small>
              <small class="text-muted" *ngIf="activeHistoryFilter === 'bike'">Órdenes de taller exclusivas de esta bicicleta</small>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span *ngIf="historyWorks.length > 0" class="badge bg-primary fs-6">
                {{ historyWorks.length }} {{ historyWorks.length === 1 ? 'Trabajo' : 'Trabajos' }}
              </span>
              <button *ngIf="selectedBikeForHistory" type="button" class="btn btn-outline-secondary btn-sm" (click)="printBikeMaintenanceHistory(selectedBikeForHistory)" title="Imprimir Historial de esta Bicicleta">
                <i class="bi bi-printer me-1"></i> Imprimir Reporte
              </button>
            </div>
          </div>

          <div class="card-body">
            <!-- Spinner cargando -->
            <div *ngIf="isLoadingHistoryWorks" class="text-center py-5">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="text-muted mt-2">Consultando historial de servicios en la base de datos...</p>
            </div>

            <!-- Sin trabajos -->
            <div *ngIf="!isLoadingHistoryWorks && historyWorks.length === 0" class="text-center py-5 text-muted">
              <i class="bi bi-journal-x display-3 d-block mb-3 text-secondary"></i>
              <h5>No se encontraron trabajos</h5>
              <p *ngIf="activeHistoryFilter">No hay órdenes de taller registradas para este criterio.</p>
              <p *ngIf="!activeHistoryFilter">Haga clic en <strong>"Ver historial de trabajos"</strong> o en una bicicleta para cargar las órdenes.</p>
            </div>

            <!-- Listado de Trabajos -->
            <div *ngIf="!isLoadingHistoryWorks && historyWorks.length > 0">
              <h6 class="small fw-bold text-muted text-uppercase mb-2">Seleccione una orden para ver su desglose:</h6>
              <div class="list-group mb-4" style="max-height: 350px; overflow-y: auto;">
                <a *ngFor="let work of historyWorks" href="javascript:void(0);"
                   class="list-group-item list-group-item-action"
                   [class.active]="selectedHistoryWork?.id === work.id"
                   (click)="selectHistoryWork(work)">
                  <div class="d-flex w-100 justify-content-between align-items-center">
                    <h6 class="mb-1 fw-bold">{{ work.caseNumber }} - {{ work.serviceType || 'Servicio' }}</h6>
                    <span class="badge" [ngClass]="getStatusClass(work.currentStatus)">{{ getSpanishStatus(work.currentStatus) }}</span>
                  </div>
                  <div class="d-flex justify-content-between align-items-center small mt-1">
                    <span class="text-truncate" style="max-width: 65%;">
                      <i class="bi bi-bicycle me-1"></i>{{ work.bikeDescription }}
                    </span>
                    <strong class="fs-6" [class.text-white]="selectedHistoryWork?.id === work.id" [class.text-success]="selectedHistoryWork?.id !== work.id">
                      {{ work.totalPrice | currency:'DOP':'RD$' }}
                    </strong>
                  </div>
                  <div class="d-flex justify-content-between align-items-center small mt-1" [class.text-white-50]="selectedHistoryWork?.id === work.id" [class.text-muted]="selectedHistoryWork?.id !== work.id">
                    <small>
                      <i class="bi bi-calendar3 me-1"></i>
                      {{ (work.entryDate?.toDate ? work.entryDate.toDate() : work.entryDate) | date:'dd/MM/yyyy HH:mm':'':'es-DO' }}
                    </small>
                    <small *ngIf="work.addedItems?.length">
                      {{ work.addedItems.length }} {{ work.addedItems.length === 1 ? 'artículo/labor' : 'artículos/labores' }}
                    </small>
                  </div>
                </a>
              </div>

              <!-- DESGLOSE COMPLETO DEL TRABAJO SELECCIONADO -->
              <div *ngIf="selectedHistoryWork" class="card border border-primary-subtle shadow-sm">
                <div class="card-header bg-primary bg-opacity-10 d-flex justify-content-between align-items-center py-2">
                  <h6 class="mb-0 fw-bold text-primary">
                    <i class="bi bi-receipt me-1"></i> Desglose de la Orden: {{ selectedHistoryWork.caseNumber }}
                  </h6>
                  <button type="button" class="btn btn-outline-primary btn-sm" (click)="printSingleWork(selectedHistoryWork, selectedClient)" title="Imprimir Orden">
                    <i class="bi bi-printer-fill me-1"></i> Imprimir Orden
                  </button>
                </div>
                <div class="card-body">
                  <div class="row g-2 mb-3">
                    <div class="col-md-6">
                      <p class="mb-1 small"><strong>Bicicleta:</strong> {{ selectedHistoryWork.bikeDescription }}</p>
                      <p class="mb-1 small"><strong>Tipo Servicio:</strong> {{ selectedHistoryWork.serviceType }}</p>
                      <p class="mb-1 small">
                        <strong>Estado:</strong> 
                        <span class="badge ms-1" [ngClass]="getStatusClass(selectedHistoryWork.currentStatus)">
                          {{ getSpanishStatus(selectedHistoryWork.currentStatus) }}
                        </span>
                      </p>
                    </div>
                    <div class="col-md-6 text-md-end">
                      <p class="mb-1 small">
                        <strong>Fecha de Recepción:</strong> 
                        {{ (selectedHistoryWork.entryDate?.toDate ? selectedHistoryWork.entryDate.toDate() : selectedHistoryWork.entryDate) | date:'dd/MM/yyyy HH:mm':'':'es-DO' }}
                      </p>
                      <h4 class="text-success mt-2 mb-0">Total: {{ selectedHistoryWork.totalPrice | currency:'DOP':'RD$' }}</h4>
                    </div>
                  </div>

                  <div *ngIf="selectedHistoryWork.description" class="p-2 mb-3 bg-light rounded small border">
                    <strong>Motivo / Descripción de Entrada:</strong>
                    <div class="text-muted mt-1">{{ selectedHistoryWork.description }}</div>
                  </div>

                  <!-- Piezas dejadas / devueltas -->
                  <div *ngIf="selectedHistoryWork.clientItems && selectedHistoryWork.clientItems.length > 0" class="alert alert-warning py-2 px-3 small mb-3">
                    <strong class="d-block mb-1"><i class="bi bi-box-seam me-1"></i>Artículos / Piezas Traídas por el Cliente (Devueltos):</strong>
                    <ul class="mb-0 ps-3">
                      <li *ngFor="let item of selectedHistoryWork.clientItems">{{ item }}</li>
                    </ul>
                  </div>

                  <!-- Artículos y Servicios Agregados -->
                  <h6 class="fw-bold small text-muted text-uppercase mb-2">Artículos y Servicios Añadidos</h6>
                  <div *ngIf="selectedHistoryWork.addedItems && selectedHistoryWork.addedItems.length > 0; else noItemsInJob">
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered table-hover small mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Descripción</th>
                            <th>Tipo</th>
                            <th class="text-center">Cant.</th>
                            <th class="text-end">Precio Unit.</th>
                            <th class="text-end">Subtotal</th>
                            <th>Asignación</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of selectedHistoryWork.addedItems">
                            <td>{{ item.productName }}</td>
                            <td>
                              <span class="badge" [ngClass]="item.itemType === 'Labor' ? 'bg-primary' : 'bg-secondary'">
                                {{ item.itemType === 'Labor' ? 'Mano de Obra' : 'Repuesto' }}
                              </span>
                            </td>
                            <td class="text-center">{{ item.quantity }}</td>
                            <td class="text-end">{{ item.unitPrice | currency:'DOP':'RD$' }}</td>
                            <td class="text-end">{{ item.unitPrice * item.quantity | currency:'DOP':'RD$' }}</td>
                            <td class="small text-muted">
                              <span *ngIf="item.mechanicName || item.assistantName">
                                {{ item.mechanicName ? 'Mec: ' + item.mechanicName : '' }}
                                {{ item.mechanicName && item.assistantName ? ' | ' : '' }}
                                {{ item.assistantName ? 'Asis: ' + item.assistantName : '' }}
                              </span>
                              <span *ngIf="!item.mechanicName && !item.assistantName">-</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <ng-template #noItemsInJob>
                    <p class="text-muted small fst-italic mb-0 py-2">No hay artículos ni servicios registrados en esta orden.</p>
                  </ng-template>

                </div>
              </div>

              <!-- Indicador si no hay trabajo seleccionado -->
              <div *ngIf="!selectedHistoryWork && historyWorks.length > 0" class="text-center py-4 text-muted bg-light rounded mt-3 border">
                <i class="bi bi-hand-index-thumb display-6 d-block mb-2 text-primary"></i>
                <span>Haga clic en cualquiera de las órdenes anteriores para ver su desglose completo de artículos, fechas y precios.</span>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>